<script context="module" lang="ts">
  export type ColorOption = {
    name: string;
    fg: string;
    highlight?: string;
  };

  export type ColorMode = "text" | "highlight";
</script>

<script lang="ts">
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { Text } from "$components/+blocks/OVIcon";

  import type { Editor } from "@tiptap/core";

  export let editor: Editor;
  export const colors: ColorOption[] = [
    { name: "Default", fg: "", highlight: "" },
    {
      name: "Primary accent",
      fg: "text-community-primary",
    },
    {
      name: "Gray",
      fg: "text-editor-gray-light dark:text-editor-gray-dark",
      highlight: "bg-editor-highlight-gray-light dark:bg-editor-highlight-gray-dark",
    },
    {
      name: "Orange",
      fg: "text-editor-orange-light dark:text-editor-orange-dark",
      highlight: "bg-editor-highlight-orange-light dark:bg-editor-highlight-orange-dark",
    },
    {
      name: "Yellow",
      fg: "text-editor-yellow-light dark:text-editor-yellow-dark",
      highlight: "bg-editor-highlight-yellow-light dark:bg-editor-highlight-yellow-dark",
    },
    {
      name: "Green",
      fg: "text-editor-green-light dark:text-editor-green-dark",
      highlight: "bg-editor-highlight-green-light dark:bg-editor-highlight-green-dark",
    },
    {
      name: "Blue",
      fg: "text-editor-blue-light dark:text-editor-blue-dark",
      highlight: "bg-editor-highlight-blue-light dark:bg-editor-highlight-blue-dark",
    },
    {
      name: "Purple",
      fg: "text-editor-purple-light dark:text-editor-purple-dark",
      highlight: "bg-editor-highlight-purple-light dark:bg-editor-highlight-purple-dark",
    },
    {
      name: "Pink",
      fg: "text-editor-pink-light dark:text-editor-pink-dark",
      highlight: "bg-editor-highlight-pink-light dark:bg-editor-highlight-pink-dark",
    },
    {
      name: "Red",
      fg: "text-editor-red-light dark:text-editor-red-dark",
      highlight: "bg-editor-highlight-red-light dark:bg-editor-highlight-red-dark",
    },
  ];

  const BUTTON_STYLES =
    "flex w-full items-center gap-2 text-xs p-1 rounded-sm hover:bg-gray-100 hover:dark:bg-white/5";

  const setHighlightColor = (color: string) => {
    // removes any existing color style to allow only colour or highlight at one time
    editor.chain().focus().unsetTextColor().run();

    if (color) {
      editor.chain().focus().setHighlight({ color }).run();
    } else {
      editor.chain().focus().unsetHighlight().run();
    }
  };
  const setTextColor = (color: string) => {
    // removes any existing highlight style to allow only colour or highlight at one time
    editor.chain().focus().unsetHighlight().run();

    if (color) {
      editor.chain().focus().setTextColor({ color }).run();
    } else {
      editor.chain().focus().unsetTextColor().run();
    }
  };
</script>

<div
  class="flex h-full w-[176px] flex-col gap-1 overflow-y-scroll rounded-md border border-gray-200 bg-white p-1 text-gray-500 dark:border-white/10 dark:bg-gray-700 dark:text-gray-300"
>
  <p class="p-1 text-xs text-gray-500 dark:text-gray-400">Colour</p>

  <!-- text color menu -->
  {#each colors as color}
    <button type="button" class={BUTTON_STYLES} on:click={() => setTextColor(color.fg)}>
      <OVIcon icon={Text} class={color.fg} />
      {color.name}
    </button>
  {/each}
  <p class="p-1 pt-1 text-xs text-gray-500 dark:text-gray-400">Highlight</p>

  <!-- highlight color menu -->
  {#each colors as color}
    {@const highlight = color.highlight}
    {#if highlight}
      <button type="button" class={BUTTON_STYLES} on:click={() => setHighlightColor(highlight)}>
        <OVIcon icon={Text} class="{color.highlight} rounded-sm" />
        {color.name} highlight
      </button>
    {/if}
  {/each}
</div>
